import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("mask", {
  id: "mask0_14513_308065",
  style: {"mask-type":"alpha"},
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createVNode("rect", {
    width: "16",
    height: "16",
    fill: "#D9D9D9"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("g", { mask: "url(#mask0_14513_308065)" }, [
  /*#__PURE__*/_createVNode("path", {
    d: "M7.33333 14.6668V11.3335C7.33333 10.7113 7.23889 10.2502 7.05 9.95016C6.86111 9.65016 6.61111 9.35572 6.3 9.06683L7.25 8.11683C7.38333 8.23905 7.51111 8.36961 7.63333 8.5085C7.75556 8.64738 7.87778 8.79461 8 8.95016C8.15556 8.73905 8.31389 8.55294 8.475 8.39183C8.63611 8.23072 8.8 8.07238 8.96667 7.91683C9.38889 7.52794 9.77222 7.07794 10.1167 6.56683C10.4611 6.05572 10.6444 5.16127 10.6667 3.8835L9.61667 4.9335L8.66667 4.00016L11.3333 1.3335L14 4.00016L13.0667 4.9335L12 3.8835C11.9778 5.47238 11.7333 6.60294 11.2667 7.27516C10.8 7.94738 10.3333 8.49461 9.86667 8.91683C9.51111 9.23905 9.22222 9.55294 9 9.8585C8.77778 10.1641 8.66667 10.6557 8.66667 11.3335V14.6668H7.33333ZM4.13333 5.45016C4.08889 5.22794 4.05833 4.9835 4.04167 4.71683C4.025 4.45016 4.01111 4.17238 4 3.8835L2.93333 4.9335L2 4.00016L4.66667 1.3335L7.33333 4.00016L6.38333 4.9335L5.33333 3.90016C5.33333 4.1335 5.34444 4.35294 5.36667 4.5585C5.38889 4.76405 5.41111 4.95572 5.43333 5.1335L4.13333 5.45016ZM5.56667 8.3835C5.34444 8.15016 5.13056 7.87794 4.925 7.56683C4.71944 7.25572 4.53889 6.87238 4.38333 6.41683L5.66667 6.10016C5.77778 6.40016 5.90556 6.65572 6.05 6.86683C6.19444 7.07794 6.35 7.26683 6.51667 7.4335L5.56667 8.3835Z",
    fill: "currentColor"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}